import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const OBGYN: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    {...props}
  >
    <style>{'.st1{fill:#002677}'}</style>
    <g id="Layer_1">
      <path
        d="M81.0595 48.7198L47.9995 81.7798L19.4195 53.1998L14.9395 48.7198C10.9995 44.7598 9.01953 39.5998 9.01953 34.4398C9.01953 29.2798 10.9995 24.0798 14.9395 20.1398C22.8195 12.2398 35.6195 12.2398 43.4995 20.1398L47.9995 24.6398L52.4995 20.1398C60.3795 12.2398 73.1795 12.2398 81.0595 20.1398C88.9595 28.0398 88.9595 40.8198 81.0595 48.7198Z"
        fill="#FF612B"
      />
      <path
        d="M63.0195 43.4004C63.0195 35.1204 56.2795 28.4004 48.0195 28.4004C39.7595 28.4004 33.0195 35.1404 33.0195 43.4004C33.0195 51.0004 38.6995 57.2804 46.0195 58.2604V62.1404H41.6995C40.5995 62.1404 39.6995 63.0404 39.6995 64.1404C39.6995 65.2404 40.5995 66.1404 41.6995 66.1404H46.0195V70.5204C46.0195 71.6204 46.9195 72.5204 48.0195 72.5204C49.1195 72.5204 50.0195 71.6204 50.0195 70.5204V66.1404H54.3395C55.4395 66.1404 56.3395 65.2404 56.3395 64.1404C56.3395 63.0404 55.4395 62.1404 54.3395 62.1404H50.0195V58.2604C57.3595 57.2804 63.0195 51.0004 63.0195 43.4004ZM59.0195 43.4004C59.0195 49.4604 54.0795 54.4004 48.0195 54.4004C41.9595 54.4004 37.0195 49.4604 37.0195 43.4004C37.0195 37.3404 41.9595 32.4004 48.0195 32.4004C54.0795 32.4004 59.0195 37.3404 59.0195 43.4004Z"
        fill="#002677"
      />
    </g>
  </Box>
)
export default OBGYN
